




import {Component} from 'vue-property-decorator';
import Vue from 'vue';
import {Action} from 'vuex-class';
import {ResponseCode} from '@/class/http';
import {AuthEnum, RegisterEnum, UserStatusEnum} from '@/store/auth/auth.enum';
import {BaseStatus} from '@/store/type';
import {Member} from '@/store/member/member.types';
import SteppersOneComponent from '@/components/register/SteppersOne.vue';


@Component({
  components: {
    SteppersOneComponent
  }
})
export default class RegisterComponent extends Vue {

  @Action('_Loading', {namespace: 'loading'}) Loading!: (payload: boolean) => Promise<void>;

  public buttonAction = false;


  async mounted() {
    await this.Loading(true);
    if (await JSON.parse(localStorage.getItem(AuthEnum.Auth) as string) as Member !== null) {
      await this.$router.push('/already-register');
    }
    await this.Loading(false);
  }


}


